import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { PageBody } from '../../../../elements/page-body';
import { toast } from 'react-toastify';
import { Input } from '../../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../../shared/http-client';
import { FieldError } from '../../../../elements/field-error/field-error';
import { Button } from '../../../../elements/button';
import { DatePicker } from '../../../../elements/date-picker';





export const GeneralTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const navigate = useNavigate();
    const [data, setData] = useState<any | null>(null);

    const initialValues: any = {
        email: '',
    };

    // Load initial data
    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);



    const beforeSubmit = (values: any) => {
        const after = { ...values };

        delete after.available;
        delete after.email;
        delete after.full_name;
        delete after.name;
        delete after.sanction_status;
        delete after.status;
        delete after.surname;
        delete after.photo;
        delete after.photo_display_url;

        return after;
    };

    const onSubmit = async (values: any) => {
        const enviaremos = beforeSubmit(values);

        const id = enviaremos.id;

        delete enviaremos.id;

        /*     let formdata = new FormData();
    
            if (enviaremos.photo) {
                if (enviaremos.photo.photo) {
                    formdata.append(
                        'photo',
                        enviaremos.photo.photo[0],
                        enviaremos.photo.photo[0].name
                    );
                }
            } */


        /*       for (let key in enviaremos) {
                  if (key !== 'photo') {
                      formdata.append(key, enviaremos[key] ? enviaremos[key] : "");
                  }
              }
       */


        api(`/fleet/drivers/${id}/`, 'PATCH', enviaremos);



    };

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('/drivers/')) {
                if (state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    navigate(-1);
                }
            }
        }

        if (state.error) {
            if (state.error.email && state.error.email == 'Driver already exists for this user') {
                toast.error(`${t('common.error.already-driver-exist')}`);
            } else if (state.error.error && state.error.error == 'El email proporcionado no existe. Para crear un nuevo usuario, debe proporcionar first_name, last_name y password.') {
                //toast.error(`${t('common.error.no-email-exist')}`);
            } else {
                toast.error('Server Error');
            }

        }
    }, [state]);


    return (
        <PageBody
        >
            <div>
                <div className='pb-2 text-[16px]'>{item?.full_name}</div>
                <div className='pb-2 text-[16px]'>{item?.email}</div>
                <div>{item?.photo_display_url ? <img
                    src={item?.photo_display_url}
                    alt="Photo"
                    className="w-[150px] h-auto"
                /> : ''}</div>

                <Formik
                    initialValues={data || initialValues}
                    onSubmit={onSubmit}
                    enableReinitialize
                >
                    {({
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        handleSubmit,
                        isSubmitting
                    }) => (
                        <form onSubmit={handleSubmit} autoComplete="off">
                            <div className='w-full py-4 flex'>

                                <>
                                    <div className='w-1/2 pl-12'>
                                        {/* <div>
                                                <span className="block text-sm font-semibold leading-6 text-gray-700">{t('common.form-label.foto')}</span>
                                                {data?.photo_display_url ? <div className=''>
                                                    <img className='w-[150px] pb-4' src={data?.photo_display_url} />
                                                </div> : id ? <div className='w-[150px] h-[168px] bg-gray-300'> </div> : ''
                                                }
                                            </div>
                                            <div className='w-full'>
                                                {id ? <span className="block text-sm font-semibold leading-6 text-gray-700">{data?.photo_display_url ? t('common.label.cambiar-foto') : t('common.label.add-foto')}</span> : ''}
                                                <FileInputElement
                                                    name="photo"
                                                    accept={'image/png, image/jpeg'}
                                                    onChange={(value) => {
                                                        // Extraemos directamente el FileList del objeto que retorna el FileInputElement
                                                        setFieldValue('photo', value);
                                                    }}
                                                />
                                            </div> */}
                                    </div>
                                </>


                            </div>
                            <div className='flex pt-4'>
                                <div className=''>
                                    <Input
                                        label={t('common.form-label.tipo-carnet')}
                                        type="text"
                                        placeholder={t('common.form-label.tipo-carnet')}
                                        name="license_types"
                                        value={values.license_types}
                                        onChange={(value) =>
                                            setFieldValue('license_types', value.license_types)
                                        }
                                    />
                                </div>
                                <div className='pl-8'>
                                    <DatePicker
                                        name="license_date"
                                        type="date"
                                        label={t(
                                            'common.label.fecha-caducidad-carnet'
                                        )}
                                        value={
                                            (data
                                                ? dayjs(
                                                    data.license_date
                                                ).format(
                                                    'YYYY-MM-DD'
                                                )
                                                : '') ||
                                            values.license_date
                                        }
                                        onChange={(value) => {
                                            setFieldValue(
                                                'license_date',
                                                value.license_date
                                                    ? dayjs(
                                                        value.license_date
                                                    ).format(
                                                        'YYYY-MM-DD'
                                                    )
                                                    : null
                                            );
                                        }}
                                    />

                                </div>
                            </div>



                            <Button
                                label={t('common.button.save')}
                                onClick={handleSubmit}
                            />
                        </form>
                    )}
                </Formik>
            </div>


        </PageBody>
    );
};